import axios from "axios";
import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/ads`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

// Advertisement CRUD API
export const createAd = async (data) => {
    try {
        const res = await api.post("/ads", data);
        return res.data;
    } catch (error) {
        console.error("Error creating advertisement:", error);
        throw error;
    }
};

export const getAds = async () => {
    try {
        const res = await api.get("/ads");
        return res.data.data;
    } catch (error) {
        console.error("Error fetching advertisements:", error);
        throw error;
    }
};

export const getAdById = async (id) => {
    try {
        const res = await api.get(`/ads/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error fetching advertisement:", error);
        throw error;
    }
};

export const updateAd = async (data) => {
    try {
        const res = await api.put(`/ads/${data.id}`, data);
        return res.data;
    } catch (error) {
        console.error("Error updating advertisement:", error);
        throw error;
    }
};

export const deleteAd = async (id) => {
    try {
        const res = await api.delete(`/ads/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting advertisement:", error);
        throw error;
    }
};

// Ad Slots CRUD API
export const createSlot = async (data) => {
    try {
        const res = await api.post("/ad-slots", data);
        return res.data;
    } catch (error) {
        console.error("Error creating slot:", error);
        throw error;
    }
};

export const getSlots = async () => {
    try {
        const res = await api.get("/ad-slots");
        return res.data.data;
    } catch (error) {
        console.error("Error fetching slots:", error);
        throw error;
    }
};

export const getAvailableSlots = async () => {
    try {
        const res = await api.get("/ad-slots/available");
        return res.data;
    } catch (error) {
        console.error("Error fetching available slots:", error);
        throw error;
    }
};

export const getSlotById = async (id) => {
    try {
        const res = await api.get(`/ad-slots/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error fetching slot:", error);
        throw error;
    }
};

export const updateSlot = async (data) => {
    try {
        const res = await api.put(`/ad-slots/${data.id}`, data);
        return res.data;
    } catch (error) {
        console.error("Error updating slot:", error);
        throw error;
    }
};

export const deleteSlot = async (id) => {
    try {
        const res = await api.delete(`/ad-slots/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting slot:", error);
        throw error;
    }
};

// Slot Allocation API
export const getSlotAllocations = async () => {
    try {
        const res = await api.get("/get-slot-allocations");
        return res.data;
    } catch (error) {
        console.error("Error fetching slot allocations:", error);
        throw error;
    }
};

export const allocateSlot = async (data) => {
    try {
        const res = await api.post("/allocate-slot", data);
        return res.data;
    } catch (error) {
        console.error("Error allocating slot:", error);
        throw error;
    }
};

export const deallocateSlot = async (id) => {
    try {
        const res = await api.delete(`/deallocate-slot/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deallocating slot:", error);
        throw error;
    }
};

export const getAllocateSlots = async (id) => {
    try {
        const res = await api.get(`/ad-slots/allocated`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching allocated slots:", error);
        throw error;
    }
};

export const calculateAdvertisementImpact = async (location, itemId) => {
    try {
        const res = await api.get("/calculate-advertisement-impact", {
            params: {
                location,
                itemId
            }
        });
        return res.data.data;
    } catch (error) {
        console.error("Error calculating advertisement impact:", error);
        throw error;
    }
};
